import ProductFieldOption from './ProductFieldOption'
import { camelize } from "../_helpers/functions"

export default class ProductField {
    id
    title
    name
    label
    position
    options
    type
    info
    video
    field_description
    selectedOption = null
    mapToForm = null

    constructor(id, title, name, label, options, position, type, field_description, info, video) {
        this.id = id || ''
        this.name = name || ''
        this.title = title || ''
        this.label = label || ''
        this.options = options || []
        this.position = position || 0
        this.type = type || ''
        this.info = info || ''
        this.video = video || ''
        this.field_description = field_description || ''
    }

    getFieldLabel() {
        return this.label ? this.label : this.name
    }
    
    getComponentName() {

        const typingMap = {
            'mirror_size': 'FieldSize',
            'glass_size': 'FieldSize',
            'size': 'FieldSize'
        }
        
        if(typingMap[this.type]){
            return camelize(typingMap[this.type])
        }

        const typingMapByName = {
            'Edging': 'ProductFields',
            'Cut Outs': 'Comment',
            'Comments': 'Comment',
            'Mirror Style': 'ProductFieldPageChange',
        }

        if(typingMapByName[this.name]){
            return camelize(typingMapByName[this.name])
        }

        return camelize(this.type)
    }

    static fromPlain(plainObj) {
        const options = []
        if (plainObj.options) {
            plainObj.options.forEach(option => {
                options.push(ProductFieldOption.fromPlain(option))
            })
        }
        
        return new ProductField(
            plainObj.id || false,
            plainObj.title || false,
            plainObj.name || false,
            plainObj.label || false,
            options || false,
            plainObj.position || false,
            plainObj.type || false,
            plainObj.field_description || false,
            plainObj.info || false,
            plainObj.video || false,
        )
    }


    static toPlain(object) {
        const plain = {}
        Object.keys(object).forEach((item, value) => {
            plain[item] = object[item]
        })
        return plain
    }
}